import { ErrorOutlineRounded, PaymentRounded } from "@mui/icons-material";
import {
  Avatar,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../App";

const Overdue = ({ invs = [] }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { branch } = useContext(AppContext);
  const [currency, setCurrency] = useState("");

  useEffect(() => {
    branch && setCurrency(branch.currency);
    return () => {};
  }, [branch]);

  const handleView = (id) => {
    navigate(`/view_member_profile/${id}`);
  };

  return (
    <Paper sx={{ padding: { xs: "10px", md: "15px" } }}>
      <div className="d-flex j-between ">
        <div>
          <h2 className="fs-18 tx-upp gray-color fw-4 m-0 d-flex">
            <PaymentRounded color="primary" /> &nbsp;&nbsp; {t("Payments")}
          </h2>
        </div>
        <div className="d-grid g-5">
          <span className="warning-color fs-12 d-flex a-center">
            <div
              style={{
                height: "10px",
                width: "10px",
                backgroundColor: "var(--warning-color)",
                borderRadius: "50%",
              }}
            />
            &nbsp; &nbsp;{t("Pending")}
          </span>
          <span className="error-color fs-12 d-flex a-center">
            <div
              style={{
                height: "10px",
                width: "10px",
                backgroundColor: "var(--error-color)",
                borderRadius: "50%",
              }}
            />
            &nbsp; &nbsp;{t("Overdue")}
          </span>
        </div>
      </div>

      <TableContainer
        className="mt-30 pr-10"
        sx={{ height: "300px", overflow: "auto" }}
      >
        <Table size="medium">
          <TableBody>
            {invs
              .filter((j) => j.status !== 2)
              .map((inv, i) => {
                var isOverdue = new Date(inv.dueDate) > new Date();
                return (
                  <TableRow hover key={i}>
                    <TableCell>
                      <Avatar src={inv.member.photo} className="shadow-md" />
                    </TableCell>
                    <TableCell sx={{ minWidth: "140px" }}>
                      <div className="d-grid">
                        <span
                          className="fw-5 fs-16 primary-color c-pointer"
                          onClick={() => handleView(inv.member.id)}
                        >
                          {inv.member.firstName + " " + inv.member.lastName}
                        </span>
                        <span className="fs-12 fw-4 grayMD-color c-pointer">
                          {inv.title} | Invoice ID: {inv.id}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell sx={{ minWidth: "150px" }}>
                      {isOverdue ? (
                        <div className="d-flex a-center bg-errorSM g-10 br-25 w-fit p-2">
                          <ErrorOutlineRounded
                            color="error"
                            className="fs-28 ml-5"
                          />
                          <div className="d-grid mr-15">
                            <span className="fw-5 fs-14 error-color">
                              {currency +
                                " " +
                                (inv.amount - inv.paidAmt).toLocaleString()}
                            </span>
                            <span className="error-color fs-12">
                              {inv.dueDate}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="d-flex a-center bg-warningXS g-10 br-25 w-fit p-2">
                          <ErrorOutlineRounded
                            color="warning"
                            className="fs-28 ml-5"
                          />
                          <div className="d-grid mr-15">
                            <span className="fw-5 fs-14 warning-color">
                              {currency +
                                " " +
                                (inv.amount - inv.paidAmt).toLocaleString()}
                            </span>
                            <span className="warning-color fs-12">
                              {inv.dueDate}
                            </span>
                          </div>
                        </div>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default Overdue;
